<template lang="pug">
  v-layout(align-start)
    v-flex
      v-data-table.elevation-1(:headers='headers' :items='prod' :search='search' sort-by='nombrePuerto' :footer-props="{itemsPerPageText: 'Puertos por página'}")
        template(v-slot:footer.page-text='items')  {{ items.pageStart }} - {{ items.pageStop }} de {{ items.itemsLength }}
        template(v-slot:top)
          v-toolbar(flat color='primary' dark)
            v-toolbar-title.justify-center.d-none.d-sm-flex(color='success') Puertos
            v-divider.mx-4(inset vertical)
            v-text-field.text-xs-center(v-model='search', label='Búsqueda', single-line, hide-details, color='success')
            v-spacer
            v-dialog(v-model='dialog' persistent content-class="flex xs12 sm6 md4")
              template( v-slot:activator='{ on }')
                v-btn.mx-2(v-show="!read" color='success' dark v-on='on') Agregar
              v-card(color='grey_1')
                v-app-bar(dark color='primary')
                  span.headline {{ formTitle }}
                v-divider
                v-card-text
                  v-row(dense)
                    v-col(cols='12')
                      v-card(color='white')
                        v-card-text
                          v-row(dense)
                            v-text-field(dense outlined v-model='form.nombrePuerto' label='Nombre del Puerto')
                v-card-actions
                  v-spacer
                  v-btn(color='error' small dark @click='close')
                    v-icon mdi-close
                    | Cancelar
                  v-btn(color='success' small dark @click='save')
                    v-icon mdi-content-save
                    | Guardar
        template(v-if="!read" v-slot:item.action='{ item }')
          v-icon.mr-2(color='warning' @click='editItem(item)') mdi-pencil
          v-icon( color='error' @click='deleteItem(item)') mdi-delete
        template(v-slot:no-data)
          h2 No hay datos de Puertos asociados
</template>

<script>
export default {
  props: ['p', 'prod', 'read'],
  data: () => ({
    dialog: false,
    headers: [
      { text: 'Puerto', value: 'nombrePuerto', align: 'center' },
      { text: 'Acciones', value: 'action', align: 'center', sortable: false }
    ],

    puerto: [],
    search: '',
    editedIndex: -1,
    form: {
      nombrePuerto: ''
    },
    defaultItem: {
      nombrePuerto: ''
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Puerto' : 'Modificar Puerto'
    }
  },

  hijo: {
    get () {
      return this.value
    },
    set (value) {
      this.$emit('input', value)
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    this.initialize()
  },

  methods: {
    initialize () {},
    editItem (item) {
      this.editedIndex = this.prod.indexOf(item)
      this.form = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.prod.indexOf(item)
      this.$swal({
        icon: 'warning',
        title: '¿Seguro que quieres borrar?',
        text: 'No podras revertir esto',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, borrar',
        cancelButtonText: 'cancelar'
      }).then(result => {
        if (result.value) {
          this.$swal('Borrado!', 'Su registro fue borrado.', 'success')
          this.prod.splice(index, 1)
        }
      })
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.form = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    validarCampos () {
      if (this.form.nombrePuerto === '') {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text: 'Por favor introduzca un puerto'
        })
        return true
      }
      return false
    },

    save () {
      if (!this.validarCampos()) {
        if (this.editedIndex > -1) {
          Object.assign(this.prod[this.editedIndex], this.form)
        } else {
          this.prod.push(this.form)
          this.$emit('input', (this.value = this.value))
        }
        this.dialog = false
        setTimeout(() => {
          this.form = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
        this.close()
      }
    }
  }
}
</script>
